import { useState, useEffect } from "react";
import StarRatings from "react-star-ratings";
import Answer from "./Answer";
import ReplyReview from "./ReplyReview";
import LongText from "./LongText";
import { formatDate } from "../../helpers/actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import ImageWithFallback from "../global/ImageWithFallback"
import { selectTextByLanguage, useGetAvailableTranslation } from "../../hooks/global/Languages";

function SingleReview({reviewId, elementDetailsVisible, isHighlighted, review:propreview, vendor, editable}) {
  const { t, i18n } = useTranslation();
  const avelibeLanguages = useGetAvailableTranslation();
  const lng = i18n.language;
  const starColor = "#f8bf2a";
  const numStars = 5;

  const [showAnswers, setShowAnswers] = useState(false);
  const [review, setReview] = useState(propreview);
  const [language, setLanguage] = useState(i18n.language);

  let commentCol = elementDetailsVisible ? "col-md-7" : "col-md-9";
  const maxChars = (text, len) => {
    if (text.length < len) return text;
    return text.slice(0, len - 3) + "...";
  };

  const refreshReview = (reply) => {
    setReview((prevReview) => ({ ...prevReview, reply }));
  };

  useEffect(() => {
    setLanguage(i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    setReview(propreview);
  }, [propreview]);

  return (
    <div
      className={"row item clearfix" + (isHighlighted ? " highlighted " : "")}
    >
      {elementDetailsVisible && (
        <div className="col-md-2 product hiddenDesktop" key={reviewId}>
          <div className="text-center">
            
            {review.product.name ? (
              <div>
                <p className="extraText">{t("admin.reviews.revFor")}</p>
                {review.product.imgUrl ? (
                  <ImageWithFallback src={review.product.imgUrl} alt={review.product.sourceId} />
                ) : (
                  <img src="/assets/img/star.png" alt="Artur.com stars" />
                )}
                 <p className="text-center">{selectTextByLanguage(JSON.parse(review.product.name), lng, avelibeLanguages)}</p>
                 <p className="text-center fs-8"><small>{selectTextByLanguage(review.productGroup.descriptiveName, lng, avelibeLanguages)}</small></p>
              </div>
            ) : (
              <div>
                <img
                  src="http://artur.com/merlin/assets/img/star.png"
                  alt="Artur.com stars"
                />
                <p className="text-center">
                  {t("admin.common.exp")} {review.company.name}
                </p>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="col-md-3 avatar">
        <div className="avatarWrap">
          <img
            src={
              review.user && review.user.avatarImage
                ? review.user.avatarImage
                : "http://artur.com/merlin/assets/img/empty_avatar.png"
            }
            alt="avatar"
          />
          <span className={review.language}></span>
        </div>

        {!vendor.anonymousReviewing &&
          review.user &&
          review.user.displayName && <h6>{review.user.displayName}</h6>}

        {!vendor.anonymousReviewing &&
          review.user &&
          !review.user.displayName && <h6>{t("admin.reviews.anonymous")}</h6>}

        {!editable && review.invitationId && (
          <div>
            <FontAwesomeIcon
              icon={faCircleCheck}
              style={{ color: "#f8bf2a" }}
            />
            <p>{t("admin.common.verCust")}</p>
          </div>
        )}

        {review.invitationReferenceNumber && editable && (
          <div>
            <p>{maxChars(review.invitationReferenceNumber, 17)}</p>
          </div>
        )}
      </div>
      <div className={commentCol + " comment text-center text-md-start"} style={{overflow: 'hidden'}}>
        <div className="rate stars starsMain center">
          <StarRatings
            style={{ width: '24px', height: '24px'}}
            ignoreInlineStyles={false}
            rating={review.score}
            starRatedColor={starColor}
            name="rating"
            numberOfStars={numStars}
            starDimension={"24"}
            starSpacing={"1"}
          />
          {review.answers && review.answers.length > 0 && (
            <a className="showMoreStars" onClick={() => setShowAnswers(!showAnswers)} >
              <span></span>
            </a>
          )}
        </div>

        <div className="commentHidden margin-top-25">
          {showAnswers &&
            review.answers.map((answer, key) => {
              return <Answer lng={lng} key={key} answer={answer} />;
            })}
        </div>

        <div className="commentLongText margin-top-25">
          <LongText content={review.text} limit={250} />
        </div>
        <p className="date center text-center text-md-start">{formatDate(review.created, language)}</p>
        <div className="commentReply margin-top-25">
          <ReplyReview
            review={review}
            editable={editable}
            vendor={vendor}
            refreshReview={refreshReview}
          />
        </div>
        {review.status !== "APPROVED" && (
          <p className="nonconfirmed">
            <FontAwesomeIcon icon="fa-solid fa-exclamation" />{" "}
            {t("admin.common.unVerRev")}
          </p>
        )}
      </div>
      {elementDetailsVisible && (
        <div className="col-md-2 product hiddenMobile">
          <div>
            {review.product.name ? (
              <div>
                {review.product.imgUrl ? (
                  <ImageWithFallback src={review.product.imgUrl} alt={review.product.sourceId} />
                ) : (
                  <img
                    src="http://artur.com/merlin/assets/img/star.png"
                    alt="Artur.com stars"
                  />
                )}
                <p className="text-center">{selectTextByLanguage(JSON.parse(review.product.name), lng, avelibeLanguages)}</p>
                <p className="text-center fs-8"><small>{selectTextByLanguage(review.productGroup.descriptiveName, lng, avelibeLanguages)}</small></p>
              </div>
            ) : (
              <div>
                <img
                  src="http://artur.com/merlin/assets/img/star.png"
                  alt="Artur.com stars"
                />
                <p className="text-center">
                  {t("admin.common.exp")} {review.company.name}
                </p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default SingleReview;
